import React, { useState } from 'react';
import './aluminiumwindow.css';

import {
  FaLeaf,
  FaSun,
  FaTint,
  FaTools,
  FaShieldAlt,
  FaSeedling
} from 'react-icons/fa';

function GreenHouses() {
  const [activeTab, setActiveTab] = useState('types');
  const [selectedImage, setSelectedImage] = useState(0);

  const images = [
    '/greenhouse1.png',
    '/greenhouse 2.jpeg',
    '/greenhouse3.webp',
    '/greenhouse4.png',
  ];

  const features = [
    {
      icon: <FaLeaf />,
      title: 'Eco-Friendly Design',
      description: 'Designed to support sustainable farming and eco-conscious cultivation'
    },
    {
      icon: <FaSun />,
      title: 'Optimal Sunlight',
      description: 'Transparent panels allow maximum sunlight penetration for healthy plant growth'
    },
    {
      icon: <FaTint />,
      title: 'Climate Control',
      description: 'Maintains ideal temperature and humidity levels throughout the year'
    },
    {
      icon: <FaTools />,
      title: 'Strong Structure',
      description: 'High-quality aluminium and steel frames for long-lasting durability'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Weather Resistant',
      description: 'Protects crops from heavy rain, wind, and extreme weather conditions'
    },
    {
      icon: <FaSeedling />,
      title: 'Higher Yield',
      description: 'Improves crop quality and productivity with controlled environments'
    }
  ];

  const greenhouseTypes = [
    // { name: 'Poly Tunnel Greenhouse', image: '/polyhouse.jpg' },
    { name: 'Glass Greenhouse', image: '/greenhouse4.png' },
    { name: 'Shade Net House', image: '/SHADE net.jpg' },
    { name: 'Commercial Greenhouse', image: '/Commercial hoses.jpg' },
  ];

  const specifications = [
    { label: 'Frame Material', value: 'Galvanized Steel / Aluminium' },
    { label: 'Covering Material', value: 'Poly Film / Glass / Shade Net' },
    { label: 'UV Protection', value: 'UV Stabilized Sheets' },
    { label: 'Ventilation', value: 'Natural & Forced Ventilation' },
    { label: 'Irrigation Support', value: 'Drip & Mist Systems Compatible' },
    { label: 'Customization', value: 'Fully Customizable Sizes & Layouts' },
    { label: 'Usage', value: 'Vegetables, Flowers, Nurseries' },
    { label: 'Warranty', value: '5–10 Years' }
  ];

  return (
    <div className="aluminium-window">

      {/* Hero Section */}
      <section className="aluminium-hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">Modern Green House Solutions</h1>
            <p className="hero-subtitle">
              High-quality greenhouse structures designed to enhance plant growth,
              improve yield, and support sustainable agriculture.
            </p>
          </div>

          <div className="hero-image">
            <img
              src={images[selectedImage]}
              alt="Green House Structure"
              className="hero-main-image"
            />
            <div className="image-thumbnails">
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Greenhouse ${index + 1}`}
                  className={`thumbnail ${selectedImage === index ? 'active' : ''}`}
                  onClick={() => setSelectedImage(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section">
        <div className="section-header">
          <h2>Why Choose Our Green Houses?</h2>
          <p>Engineered for productivity, protection, and sustainability</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Tabs */}
      <section className="tabs-section">
        <div className="tabs-header">
          <button
            className={`tab-btn ${activeTab === 'types' ? 'active' : ''}`}
            onClick={() => setActiveTab('types')}
          >
            Green House Types
          </button>

          <button
            className={`tab-btn ${activeTab === 'benefits' ? 'active' : ''}`}
            onClick={() => setActiveTab('benefits')}
          >
            Benefits
          </button>
        </div>

        <div className="tabs-content">

          {activeTab === 'types' && (
            <div className="window-types-grid">
              {greenhouseTypes.map((type, index) => (
                <div key={index} className="window-type-card">
                  <img src={type.image} alt={type.name} />
                  <h4>{type.name}</h4>
                </div>
              ))}
            </div>
          )}

          {activeTab === 'benefits' && (
            <div className="benefits-content">
              <div className="benefit-card">
                <h3>Year-Round Cultivation</h3>
                <p>Grow crops regardless of seasonal climate changes.</p>
              </div>
              <div className="benefit-card">
                <h3>Improved Crop Quality</h3>
                <p>Controlled environments lead to healthier and uniform crops.</p>
              </div>
              <div className="benefit-card">
                <h3>Water Efficiency</h3>
                <p>Reduces water consumption through efficient irrigation systems.</p>
              </div>
              <div className="benefit-card">
                <h3>Pest Protection</h3>
                <p>Minimizes exposure to pests and plant diseases.</p>
              </div>
            </div>
          )}

        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Grow Smarter with Green Houses</h2>
          <p>Contact us today for customized greenhouse solutions</p>
          <div className="cta-buttons">
            <a href="/contactus">
              <button className="btn-outline">Contact Us</button>
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-grid">
          <div className="faq-item">
            <h4>What crops can be grown in a greenhouse?</h4>
            <p>Vegetables, flowers, fruits, herbs, and nursery plants.</p>
          </div>
          <div className="faq-item">
            <h4>Are greenhouses customizable?</h4>
            <p>Yes, size, structure, covering material, and ventilation can be customized.</p>
          </div>
          <div className="faq-item">
            <h4>Do greenhouses protect from extreme weather?</h4>
            <p>Yes, they protect crops from rain, wind, excessive heat, and cold.</p>
          </div>
          {/* <div className="faq-item">
            <h4>Is installation provided?</h4>
            <p>Yes, we offer complete supply and professional installation services.</p>
          </div> */}
        </div>
      </section>

    </div>
  );
}

export default GreenHouses;
